<ng-container *ngIf="!user; else signedIn">
  <app-signin></app-signin>
</ng-container>

<ng-template #signedIn>
  <app-kunde-buchungen [user]="user"></app-kunde-buchungen>
  <br>
  <app-kunde-rechnung [user]="user"></app-kunde-rechnung>
  <br>
  <app-kunde-zahlung [user]="user"></app-kunde-zahlung>
  <br>
  <app-kunde-zahlungen [user]="user"></app-kunde-zahlungen>
</ng-template>
